import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FocusableComponent } from '@shareview/shared/focusable';
import { YoutubeVideoPlayerComponent } from '../../components/youtube-video-player';
import { YoutubeVideoPlayerDialogData } from '../../types/youtube-video-player-dialog-data';

@Component({
  selector: 'hh-youtube-video-player-dialog',
  standalone: true,
  imports: [CommonModule, YoutubeVideoPlayerComponent],
  templateUrl: './youtube-video-player-dialog.component.html',
  styleUrls: ['./youtube-video-player-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YoutubeVideoPlayerDialogComponent extends FocusableComponent {
  private _dialogRef = inject(MatDialogRef<YoutubeVideoPlayerDialogComponent>);
  private _dialogData: YoutubeVideoPlayerDialogData = inject(MAT_DIALOG_DATA);

  protected get videoId(): string {
    return this._dialogData.videoId;
  }

  public override handleKeyPress(event: KeyboardEvent): boolean {
    switch (event.key) {
      // TODO Add player key cases.

      case 'Escape':
      case 'XF86Back':
        this._dialogRef.close();
        return true;

      default:
        return super.handleKeyPress(event);
    }
  }
}
